/* Action types */
export const actionTypes = {
    GET_MY_PROFILE_SUCCESS: 'ACCOUNT/GET_MY_PROFILE_SUCCESS',
    LOGOUT_USER: 'ACCOUNT/LOGOUT_USER',
};
